module.exports = __webpack_public_path__ + "media/images/area/area_kochiM400-c1620cd7b0bf8fd8600c65dd831d9e3c.jpg";